module.exports = __webpack_public_path__ + "static/media/ic_proyecto_circulo_borde_verde.c19577da.svg";